import { createSlice } from "@reduxjs/toolkit";


export const resaSlice = createSlice({
    name: 'resa',
    initialState:{},
    reducers: { // 
        setResa: (currentState, action) => {
            return (action.payload);
        },
        modifCouponResa: (currentState, action) => {
            let newResa = {...currentState,
                coupon:action.payload,
                Client:currentState.Client,
                CreneauEleves:currentState.CreneauEleves,
                ResaCommentaires:currentState.ResaCommentaires};
            console.log(newResa);
            return (newResa);
        },
       
    }
});

